import React, { Component } from 'react';
import { getBoardingStatusSummaryLegacy as fetchBoardingStatusSummary } from './boardingStatusSummaryActions';
import { getIsBoardingStatusSummaryLoading, getBoardingStatusSummary } from './boardingStatusSummaryEntity';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './BoardingStatusSummaryWidgetLegacy.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

const BOARDING_STATUSES = [
    'App Created',
    'Merchant Signed',
    'Sales Agent Signed',
    'Received',
    'Pending',
    'Boarded',
    'Live',
    'Declined'
];

const boardingStatusSummaryShape = PropTypes.shape({
    pending: PropTypes.number,
    boarding: PropTypes.number,
    live: PropTypes.number,
    declined: PropTypes.number
});

export class BoardingStatusSummaryWidgetLegacy extends Component {
    static propTypes = {
        history: PropTypes.any,
        boardingStatusSummary: boardingStatusSummaryShape,
        onGetBoardingStatusSummary: PropTypes.func,
        isLoading: PropTypes.bool,
        setFilter: PropTypes.func
    };

    componentDidMount() {
        this.props.onGetBoardingStatusSummary();
    }

    boardingStatusCardOnClick = (status) => {
        this.props.history.push(`/boardingStatus?status=${status}`);

        if (_.has(this.props, 'setFilter')) {
            this.props.setFilter(status);
        }
    };

    renderCards = () => {
        const arrayMid = _.ceil(BOARDING_STATUSES.length / 2);
        const row1Statuses = _.slice(BOARDING_STATUSES, 0, arrayMid);
        const row2Statuses = _.slice(BOARDING_STATUSES, arrayMid);

        return <div className="boarding-status-summary-cards">
            {_.map([row1Statuses, row2Statuses], (row, index) => {
                return <div className="boarding-status-summary-row" key={`${index}-${row.join(',')}`}>
                    {_.map(row, (boardingStatus) => this.renderCard(boardingStatus))}
                </div>;
            })}
        </div>;
    };

    renderCard = (boardingStatus) => {
        return (
            <div className="boarding-status-card" onClick={() => this.boardingStatusCardOnClick(boardingStatus)} key={boardingStatus}>
                <div className="boarding-status-text">
                    {boardingStatus}
                </div>
                <div className="boarding-status-value">
                    {
                        this.props.isLoading ?
                            '--'
                            : _.get(this.props.boardingStatusSummary, _.camelCase(boardingStatus))
                    }
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="boarding-status-summary-widget-legacy">
                {this.renderCards()}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        isLoading: getIsBoardingStatusSummaryLoading(state),
        boardingStatusSummary: getBoardingStatusSummary(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onGetBoardingStatusSummary: () => dispatch(fetchBoardingStatusSummary())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BoardingStatusSummaryWidgetLegacy));
